import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Text } from '../../Text';
import { Tooltip } from '../../Tooltip';
import moduleStyles from '@dtsl/css-list/dist/index.module.css';
function ListMetricsTitle(props) {
  const {
    title
  } = props;
  const matricsTitleRef = useRef(null);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  useEffect(() => {
    if (matricsTitleRef && matricsTitleRef.current) {
      const {
        offsetWidth,
        scrollWidth
      } = matricsTitleRef.current;
      if (offsetWidth < scrollWidth) {
        setIsTooltipVisible(true);
      } else {
        setIsTooltipVisible(false);
      }
    }
  }, []);
  const titleJSX = /*#__PURE__*/React.createElement(Text, {
    size: "sm",
    color: "var(--sib-color_content-secondary)",
    className: moduleStyles['sib-list__metric-label']
  }, title);
  return /*#__PURE__*/React.createElement("div", {
    ref: matricsTitleRef
  }, isTooltipVisible ? /*#__PURE__*/React.createElement(Tooltip, {
    text: title,
    placement: "top"
  }, titleJSX) : titleJSX);
}
ListMetricsTitle.propTypes = {
  title: PropTypes.string.isRequired
};
export default ListMetricsTitle;